import React from 'react';
import pt from 'prop-types';

import { PARTNER_CAPABILITIES } from 'partners/shared/capabilities';

import Button from 'components/button';
import Link from 'components/link';
import { Form, Field } from 'components/form';
import { FadeInPop } from 'components/transitions';

import './signup.scss';

export default class SignupExpertise extends React.PureComponent {
  static propTypes = {
    values: pt.object,
    onSubmit: pt.func,
    onBack: pt.func,
  };

  render() {
    const { values, onSubmit, onBack } = this.props;

    return (
      <FadeInPop>
        <div>
          <div className="signup-header">
            <div className="signup-subtitle">
              Select all that apply to your business
            </div>
          </div>

          <Form onSubmit={onSubmit}>
            <Field
              type="checkbox"
              name="capabilities"
              options={PARTNER_CAPABILITIES}
              defaultValue={values.capabilities}
              display="chips"
            />

            <div className="signup-actions">
              <Button size="large" type="submit" className="signup-submit">
                Next
              </Button>

              <Link className="signup-back" onClick={onBack}>
                ← Back to previous step
              </Link>
            </div>
          </Form>
        </div>
      </FadeInPop>
    );
  }
}
